import React from "react"

const Button = () => {
    return (
        <button className="button"><a href="#button">explore</a></button>
    )
}

export default Button;